// tslint:disable:no-any (autogenerated)
// tslint:disable:promise-function-async (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
import { dispatch, getState, subscribe } from './redux-store';
import dispatcher from './dispatcher';
import { assign } from 'lodash';
import { genericStoreAction } from './generic-store-reducer';

let guid = 1;
/**
 * @deprecated use redux directly
 */
class BaseStore<StateType> implements IBaseStore<StateType> {
    public dispatcherEvents: (IDispatchEventObject | string)[] | string = [];
    public dispatcherResetEvent: string;
    /**
     * Initial state
     */
    protected initialState: StateType = {} as StateType;
    protected storeId: string;
    private subscribers: {
        context?: any;
        handler(state?: StateType): void;
    }[] = [];

    private tempState: any = null;
    private prevState: any = null;

    /**
     * id таймаута для применения изменений стейта
     * @type {number}
     */
    private timer: number = undefined;
    /**
     * Време не чаще которого будут применяться изменения стейта
     * @type {number}
     */
    private timeout: number = 15;

    // todo: use immutable js instead of plain clone
    public getState(): StateType {
        return getState().generic[this.storeId] as StateType || this.initialState;
    }

    /**
     * @deprecated use getState
     */
    public getImmediateState(): StateType {
        if (this.tempState) {
            return this.tempState;
        }
        return this.getState();
    }

    /**
     * @deprecated use redux directly
     */
    public on<T>(eventName: string, handler: (state?: StateType) => void, context?: T): void {
        if (eventName !== 'change') {
            console.warn('Unsafe store event type!', eventName);
        }
        if (this.subscribers.filter(s => s.handler === handler).length === 0) {
            this.subscribers.push({ handler, context });
        }
    }

    /**
     * @deprecated use redux directly
     */
    public off(eventName: string, handler: (state?: StateType) => void): void {
        if (eventName !== 'change') {
            console.warn('Unsafe store event type!', eventName);
        }
        this.subscribers = this.subscribers.filter(s => s.handler !== handler);
    }

    protected onReduxStoreChange = () => {
        const state = this.getState();
        if (state !== this.prevState) {
            this.prevState = state;
            this.subscribers.forEach(
                // tslint:disable-next-line:no-void-expression (autogenerated)
                s => (s.context ? s.handler.call(s.context, state) : s.handler(state))
            );
        }
    };

    public initialize(storeId: string): IBaseStore<StateType> {
        this.storeId = storeId;
        this.registerStore();
        this.updateState(this.initialState);
        subscribe(this.onReduxStoreChange);
        return this;
    }

    public resetState(): void {
        this.updateState(this.initialState);
    }

    public updateState(newState: Partial<StateType>): void {
        this.tempState = assign({}, this.tempState || this.getState(), newState);
        this.triggerState(this.tempState);
    }

    private wait(): Promise<{}> {
        // tslint:disable-next-line:no-this-assignment (autogenerated)
        const self = this;
        // tslint:disable-next-line:no-inferred-empty-object-type (autogenerated)
        return new Promise(resolve => {
            self.timer = window.setTimeout(() => {
                resolve();
                self.timer = undefined;
            }, self.timeout);
        });
    }

    private registerStore(): void {
        if (BaseStore.isString(this.dispatcherEvents)) {
            this.registerByString(this.dispatcherEvents as string);
        } else {
            this.registerByArray(this.dispatcherEvents as (IDispatchEventObject | string)[]);
        }

        const dispatcherResetEvent = this.dispatcherResetEvent;
        if (BaseStore.isString(dispatcherResetEvent) && dispatcherResetEvent !== '') {
            dispatcher.register(dispatcherResetEvent, this.resetState, this);
        }
    }

    private registerByArray(dispatchEvents: (IDispatchEventObject | string)[]): void {
        dispatchEvents.forEach((toDispatch: IDispatchEventObject | string) => {
            if (BaseStore.isString(toDispatch)) {
                this.registerByString(toDispatch as string);
            } else {
                this.registerByObject(toDispatch as IDispatchEventObject);
            }
        });
    }

    private registerByObject(dispatchObject: IDispatchEventObject): void {
        const handler = dispatchObject.handler || this.updateState;
        const context = dispatchObject.context || this;
        dispatcher.register(dispatchObject.eventName, handler, context);
    }

    private registerByString(eventName: string): void {
        this.storeId = this.storeId || `${guid++}#${eventName}`;
        dispatcher.register(eventName, this.updateState, this);
    }

    protected innerUpdateState<T>(newState: T): void {
        dispatch(genericStoreAction(this.storeId, newState));
        this.tempState = null;
    }

    private triggerState(newState: StateType): void {
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.wait().then(() => {
            this.innerUpdateState(newState);
        });
    }

    private static isString(some: any): boolean {
        return typeof some === 'string';
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default BaseStore;
